import { render, staticRenderFns } from "./FreeCardDetail.vue?vue&type=template&id=2bf082da&scoped=true&"
import script from "./FreeCardDetail.vue?vue&type=script&lang=js&"
export * from "./FreeCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./FreeCardDetail.vue?vue&type=style&index=0&id=2bf082da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf082da",
  null
  
)

export default component.exports